export default __webpack_public_path__ + "static/sms-2d1fff51c58680307be0071f83191b30.png";